// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { thunderTestnet as _thunderTestnet } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the thunderTestnet chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 997
 * Chain Name: 5ireChain Thunder Testnet
 * Default Block Explorer: https://explorer.5ire.network
 * Default RPC URL: https://rpc-testnet.5ire.network
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { thunderTestnet } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: thunderTestnet,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const thunderTestnet = createCommon({
	..._thunderTestnet,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
